import type { ClaimStatus } from "../types";

export function ClaimStatusBadge({ status }: { status: ClaimStatus }) {
  const styles: Record<ClaimStatus, string> = {
    DRAFT: "bg-slate-100 text-slate-700 ring-slate-200",

    PENDING_APPROVAL: "bg-amber-100 text-amber-800 ring-amber-200",

    APPROVED: "bg-emerald-100 text-emerald-800 ring-emerald-200",

    REJECTED: "bg-rose-100 text-rose-800 ring-rose-200",

    CANCELLED: "bg-slate-200 text-slate-700 ring-slate-300",

    PAID: "bg-indigo-100 text-indigo-800 ring-indigo-200",
  };

  return (
    <span
      className={`inline-flex rounded-full px-3 py-1 text-xs font-semibold ring-1 ${styles[status]}`}
    >
      {status.replaceAll("_", " ")}
    </span>
  );
}
